import React from 'react';
import PropTypes from 'prop-types';
import { Route } from "react-router-dom";
import UiUtils from '../../utils/UiUtils';
import SearchBar from '../../components/search-bar/SearchBar';
import AutomotoresBusqueda from "./components/automotores-busqueda/AutomoresBusqueda";
import { AUTOMOTORES_SEARCH_OPTIONS } from '../../config';

class Automotores extends React.Component {

  onBusquedaHandler = (tipo, valor) => {
    UiUtils.navigateTo(`/dashboard/Automotores/busqueda/${tipo}/${valor}`);
  }

  onResultadoSeleccionado = (valor, isPerson) => {
    UiUtils.navigateTo(`/dashboard/${isPerson ? 'personas' : 'empresas'}/detalle/${valor}`);
  }

  render() {

    return (
      <div>
        <SearchBar opciones={AUTOMOTORES_SEARCH_OPTIONS} onBusqueda={this.onBusquedaHandler} />
        <Route path={`${this.props.match.url}/busqueda/:tipo/:valor`} render={({ match }) => {
          return (
            <AutomotoresBusqueda tipo={match.params.tipo} valor={match.params.valor}
              onResultadoSeleccionado={this.onResultadoSeleccionado} />
          )
        }} />
      </div>
    );
  }
}

Automotores.propTypes = {
  match: PropTypes.object
}

export default Automotores;



// WEBPACK FOOTER //
// ./src/scenes/automotores/Automotores.js